import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-graph-export-popup',
  templateUrl: './graph-export-popup.component.html',
  styleUrls: ['./graph-export-popup.component.scss']
})
export class GraphExportPopupComponent implements OnInit {

  @Input() containerHeight_Input: number;
  @Input() title: string;

  @Output() render_output = new EventEmitter();
  public modalService: NgbModal;
  containerHeight: number;
  popUpTitle:string

  constructor(public activeModel: NgbActiveModal) { }

  ngOnInit(): void {
    this.containerHeight = this.containerHeight_Input || 1000;
    this.popUpTitle = this.title;
  }

  close() {
    this.activeModel.close(this.containerHeight_Input);
  }

  ngAfterViewInit() {
    this.render_output.emit();
  }

}
